import './legacy_jquery'

window.remove_fields = function (link) {
  $(link).prev("input[type=hidden]").val("1");
  $(link).closest(".fields").hide();
  if (link.dataset.hideButtonIdData && link.dataset.hideButtonIdData.trim() !== "") {
    const targetElement = document.getElementById(link.dataset.hideButtonIdData.trim());
    if (targetElement) {
      if (targetElement.classList.contains('d-none')) {
        targetElement.classList.remove('d-none');
        targetElement.classList.add('d-block');
      }
    }
  }
}

window.add_fields = function (link, hide_button, id, association, content) {
  if (hide_button.trim() === 'true') {
    document.getElementById(id.trim()).classList.add('d-none');
  }
  var new_id = new Date().getTime();
  var regexp = new RegExp("new_" + association, "g");
  let html = $(content.replace(regexp, new_id));
  html.attr("data-index", new_id);
  $(link).append(html);
  return html;
}